import CategorySelector from '~/containers/searchform/category_selector'

export default CategorySelector

